export default {
    // Temp fonts
    fonts: {
      title: "Space Grotesk, sans-serif",
      main: "Space Grotesk, sans-serif"
    },
    // Colors for layout
    colors: {
      primary1: "#854CE6",
      background1: "#000000",
      button: "#854CE6",
      background2: "#000000",
      text: "#C8CFD8",
      text1: "#F2F5F7",
      text2: "#626970",
      text3: "#575C66",
      footerBackground: "#00012B"
    },
    // Breakpoints for responsive design
    breakpoints: {
      sm: 'screen and (max-width: 640px)',
      md: 'screen and (max-width: 768px)',
      lg: 'screen and (max-width: 1024px)',
      xl: 'screen and (max-width: 1280px)'
    },
  }